export enum CHART_OF_ACCOUNTS_REFERENCE_CATEGORIES {
  STATEMENTS = 'STATEMENTS',
  LEDGER_CATEGORY = 'LEDGER CATEGORIES',
  LEDGER_TYPE = 'LEDGER TYPES',
}
